var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model)?_c('v-list',{attrs:{"color":"transparent"}},[_vm._l((_vm.model),function(mail,index){return [_c('mail-item',{key:index,attrs:{"mail":mail}})]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }